import fetch from '@/service/fetch';

export function getMsgList(params) {
  return fetch('/api/u-portal/msg/mail/page', {
    data: params
  })
}

export function getUnReadTotal() {
  return fetch('/api/u-portal/msg/mail/un-read-cnt')
}

export function getAllUnReadTotal() {
  return fetch('/api/u-portal/msg/mail/un-read-total')
}

export function readMail(params) {
  return fetch('/api/u-portal/msg/mail/read', {
    data: params,
    method: 'POST'
  })
}

export function resetUserInfo(params) {
  return fetch('/api/u-portal/auth/user/edit', {
    data: params,
    method: 'POST'
  })
}

export function resetUserPwd(params) {
  return fetch('/api/u-portal/auth/reset-pwd', {
    data: params,
    method: 'POST'
  })
}

export function resetUserOrg(params) {
  return fetch('/api/u-portal/mem/org/edit', {
    data: params,
    method: 'POST'
  })
}

export function payMemFee(params) {
  return fetch('/api/u-portal/auth/pay-mem-fee', {
    data: params,
    method: 'POST'
  })
}

export function getMemOrgLinkList(params) {
  return fetch('/api/u-portal/mem/org/linkman/list', {
    data: params
  })
}

export function addMemOrgLink(params) {
  return fetch('/api/u-portal/mem/org/linkman/save', {
    data: params,
    method: 'POST'
  })
}

export function removeMemOrgLink(params) {
  return fetch(`/api/u-portal/mem/org/linkman/remove/${params.id}`, {
    method: 'POST'
  })
}

export function editMemOrgLink(params) {
  return fetch('/api/u-portal/mem/org/linkman/edit', {
    data: params,
    method: 'POST'
  })
}

export function getMemOrgLinkDetail(params) {
  return fetch(`/api/u-portal/mem/org/find/${params.id}`)
}

export function getUserActList(params) {
  return fetch('/api/u-portal/act/page', {
    data: params
  })
}

export function getUserPublishList(params) {
  return fetch('/api/u-portal/cbt/publication/page', {
    data: params
  })
}

export function getUserAwardList(params) {
  return fetch('/api/u-portal/act/award/page', {
    data: params
  })
}

export function addParcelInfo(params) {
  return fetch('/api/u-portal/act/award/fill-parcel', {
    data: params,
    method: 'POST'
  })
}

export function cancelSignUpAward(params) {
  return fetch('/api/u-portal/act/cancel-sign-up-award', {
    data: params,
    method: 'POST'
  })
}

export function reUploadScanningCopy(params) {
  return fetch('/api/u-portal/act/reupload-scanning-copy', {
    data: params,
    method: 'POST'
  })
}

export function getAbortReason(params) {
  return fetch(`/api/u-portal/cbt/publication/find/${params.id}/failed/msg`);
}

export function getAwardInfo(id) {
  return fetch(`/api/u-portal/act/sign-up-award/find/${id}`);
}

export function getGreatEventList(params) {
  return fetch('/api/u-portal/mem/org/great-event/page', {
    data: params
  })
}

export function addGreatEvent(params) {
  return fetch('/api/u-portal/mem/org/great-event/save', {
    data: params,
    method: 'POST'
  })
}

export function editGreatEvent(params) {
  return fetch('/api/u-portal/mem/org/great-event/edit', {
    data: params,
    method: 'POST'
  })
}

export function removeGreatEvent(params) {
  return fetch(`/api/u-portal/mem/org/great-event/remove/${params.id}`, {
    method: 'POST'
  })
}

export function getWinAwardList(params) {
  return fetch('/api/u-portal/mem/org/win-award/page', {
    data: params
  })
}

export function addWinAward(params) {
  return fetch('/api/u-portal/mem/org/win-award/save', {
    data: params,
    method: 'POST'
  })
}

export function editWinAward(params) {
  return fetch('/api/u-portal/mem/org/win-award/edit', {
    data: params,
    method: 'POST'
  })
}

export function removeWinAward(params) {
  return fetch(`/api/u-portal/mem/org/win-award/remove/${params.id}`, {
    method: 'POST'
  })
}

export function configInvoiceBuyerInfo(params) {
  return fetch('/api/u-portal/apply/invoice/config-invoice-buyer-info', {
    method: 'POST',
    data: params
  })
}

export function getInvoiceBuyerInfo(params) {
  return fetch('/api/u-portal/apply/invoice/invoice-buyer-info/detail', {
    data: params
  })
}

export function getTodoPayRecordList(params) {
  return fetch('/api/u-portal/apply/invoice/todo-pay-record/list', {
    data: params
  })
}

export function applyInvoice(params) {
  return fetch('/api/u-portal/apply/invoice/save', {
    data: params,
    method: 'POST'
  })
}

export function getInvoiceApplyList(params) {
  return fetch('/api/u-portal/apply/invoice/page', {
    data: params
  })
}
